{
  "helloWorld": "¡Hola, Mundo!",
  "clickMe": "Haz clic aquí",
  "healthCheckFailed": "Error en la verificación de estado",
  "errors": {
    "unexpected": "Ocurrió un error inesperado"
  },
  "error": {
    "title": "Algo salió mal",
    "description": "Ocurrió un error inesperado. Puedes intentarlo de nuevo o volver al inicio.",
    "tryAgain": "Intentar de nuevo",
    "goHome": "Ir al inicio"
  },
  "dev": {
    "errorPreview": "Vista previa de error"
  },
  "actions": {
    "label": "Acciones",
    "edit": "Editar",
    "delete": "Eliminar",
    "save": "Guardar",
    "cancel": "Cancelar",
    "expand": "Expandir",
    "collapse": "Colapsar"
  },
  "validation": {
    "tooLong": "Debe tener {{max}} caracteres o menos",
    "tooShort": "Requerido",
    "invalidFormat": "Formato inválido",
    "invalid": "Valor inválido"
  },
  "nav": {
    "workspace": "Espacio de trabajo",
    "controlCenter": "Centro de control",
    "jobs": "Empleos",
    "analytics": "Analíticas",
    "company": "Empresa",
    "agentCommunications": "Comunicaciones de agente",
    "integrations": "Integraciones",
    "suggestedCandidates": "Candidatos sugeridos",
    "unsolicitedApplications": "Solicitudes no solicitadas",
    "team": "Equipo",
    "templates": "Plantillas",
    "workflow": "Flujo de trabajo",
    "settings": "Configuración",
    "language": "Idioma",
    "help": "Ayuda",
    "logout": "Cerrar sesión",
    "administration": "Administración",
    "adminTenant": "Configuración del tenant",
    "adminOrganizations": "Organizaciones",
    "adminDepartments": "Departamentos",
    "adminFeedback": "Comentarios",
    "openMenu": "Abrir menú",
    "mcp": "MCP",
    "orgSettings": "Configuración de organización"
  },
  "admin": {
    "tenants": {
      "title": "Tenants",
      "newTenant": "Nuevo tenant",
      "columns": {
        "name": "Nombre",
        "createdAt": "Creado el",
        "actions": "Acciones"
      },
      "createDialog": {
        "title": "Crear tenant",
        "namePlaceholder": "Acme Corp"
      },
      "editDialog": {
        "title": "Editar tenant"
      }
    },
    "tenant": {
      "title": "Configuración del tenant",
      "name": "Nombre del tenant",
      "save": "Guardar cambios",
      "saved": "Guardado"
    },
    "organizations": {
      "title": "Organizaciones",
      "newOrg": "Nueva organización",
      "columns": {
        "name": "Nombre",
        "slug": "Slug",
        "tenant": "Tenant",
        "createdAt": "Creado el",
        "actions": "Acciones",
        "viewWorkspace": "Ver espacio de trabajo"
      },
      "createDialog": {
        "title": "Crear organización",
        "namePlaceholder": "Acme Corp",
        "slugPlaceholder": "acme-corp",
        "newTenant": "Nuevo tenant",
        "existingTenant": "Tenant existente",
        "tenantName": "Nombre del tenant",
        "tenantNamePlaceholder": "Acme Corp",
        "selectTenant": "Seleccionar tenant"
      },
      "editDialog": {
        "title": "Editar organización",
        "language": "Idioma",
        "languagePlaceholder": "Seleccionar idioma"
      },
      "deleteConfirm": {
        "title": "Eliminar organización",
        "description": "Esto también eliminará todos los departamentos de esta organización. Esta acción no se puede deshacer.",
        "confirm": "Eliminar",
        "cancel": "Cancelar"
      }
    },
    "departments": {
      "title": "Departamentos",
      "newDept": "Nuevo departamento",
      "columns": {
        "name": "Nombre",
        "slug": "Slug",
        "createdAt": "Creado el",
        "actions": "Acciones"
      },
      "createDialog": {
        "title": "Crear departamento",
        "namePlaceholder": "Ingeniería",
        "slugPlaceholder": "ingenieria"
      },
      "editDialog": {
        "title": "Editar departamento"
      },
      "deleteConfirm": {
        "title": "Eliminar departamento",
        "description": "Esta acción no se puede deshacer.",
        "confirm": "Eliminar",
        "cancel": "Cancelar"
      }
    },
    "viewingOrg": {
      "banner": "Viendo: {{name}}",
      "leave": "Salir"
    },
    "feedback": {
      "title": "Comentarios",
      "columns": {
        "rating": "Valoración",
        "modality": "Tipo",
        "candidate": "Candidato",
        "job": "Puesto",
        "org": "Organización",
        "notes": "Notas",
        "date": "Fecha"
      },
      "modality": {
        "voice": "Voz",
        "text": "Chat"
      },
      "thumbs": {
        "up": "Positivo",
        "down": "Negativo"
      },
      "filter": {
        "all": "Todos",
        "up": "Positivo",
        "down": "Negativo",
        "hasNotes": "Con notas"
      },
      "stats": {
        "title": "Tasa negativa",
        "period": "Últimos 7 días",
        "wowUp": "+{{delta}}pp",
        "wowDown": "-{{delta}}pp",
        "wowFlat": "Sin cambio",
        "wowNoPrev": "Sin datos ant.",
        "noData": "Sin datos"
      },
      "noFeedback": "Aún no hay comentarios",
      "noNotes": "Sin comentario escrito"
    }
  },
  "team": {
    "title": "Equipo",
    "invite": "Invitar colegas",
    "search": "Buscar por nombre, email, departamento...",
    "department": "Departamento",
    "roles": {
      "admin": "Admin",
      "org_manager": "Gestor de organización",
      "dept_manager": "Gestor de Departamento",
      "user": "Usuario"
    },
    "columns": {
      "name": "Nombre",
      "email": "Correo",
      "role": "Rol",
      "actions": "Acciones"
    },
    "inviteDialog": {
      "title": "Invitar colega",
      "name": "Nombre",
      "namePlaceholder": "Juan Pérez",
      "email": "Correo electrónico",
      "emailPlaceholder": "colega@empresa.com",
      "role": "Rol",
      "departments": "Departamentos",
      "submit": "Enviar invitación"
    },
    "actions": {
      "changeRole": "Cambiar rol",
      "addDepartment": "Añadir a departamento",
      "removeDepartment": "Quitar de departamento",
      "removeFromOrg": "Eliminar de la organización"
    },
    "noResults": "No se encontraron resultados.",
    "noMembers": "Aún no hay miembros del equipo."
  },
  "jobs": {
    "title": "Empleos",
    "backToJobs": "Empleos",
    "newJob": "Nuevo empleo",
    "createNewJob": "Crear nuevo empleo",
    "importFromAts": "Importar desde {{atsName}}",
    "searchPlaceholder": "Buscar empleos...",
    "completedPlaceholder": "{{completed}} de {{total}} completados",
    "tabs": {
      "active": "Activos",
      "archived": "Archivados"
    },
    "columns": {
      "name": "Nombre",
      "createdBy": "Creado por",
      "createdAt": "Creado el",
      "actions": "Acciones"
    },
    "empty": "No se encontraron empleos.",
    "emptyTitle": "Aún no hay empleos",
    "emptyDescription": "Crea tu primer empleo o importa desde tu ATS para comenzar.",
    "emptyArchivedTitle": "No hay empleos archivados",
    "emptyArchivedDescription": "Los empleos archivados aparecerán aquí.",
    "emptySearchDescription": "Ningún empleo coincide con tu búsqueda.",
    "actions": {
      "archive": "Archivar",
      "archiveConfirmTitle": "Archivar empleo",
      "archiveConfirmDescription": "¿Estás seguro de que quieres archivar este empleo? Se moverá a la pestaña Archivados.",
      "archiveSuccess": "Empleo archivado",
      "archiveError": "No se pudo archivar el empleo. Inténtalo de nuevo."
    },
    "createError": "Error al crear el empleo. Por favor, inténtalo de nuevo.",
    "status": {
      "active": "Activo",
      "archived": "Archivado"
    },
    "setupStatus": {
      "draft": "Borrador",
      "questions_pending": "Configuración pendiente",
      "ready": "Listo",
      "active": "Activo"
    },
    "applicantSync": {
      "syncingBanner": "Obteniendo candidatos de {{provider}}...",
      "failedBanner": "Error al sincronizar candidatos",
      "adminActions": "Acciones de administrador",
      "resyncLabel": "Sincronizar candidatos ahora",
      "lastSyncedAt": "Última sincronización: {{date}}",
      "addDemoApplicant": "Agregar candidato de demostración"
    },
    "detail": {
      "tabs": {
        "candidates": "Candidatos",
        "results": "Resultados",
        "settings": "Configuración"
      },
      "info": {
        "title": "Información del puesto",
        "employer": "Empleador",
        "location": "Ubicación",
        "description": "Descripción",
        "modality": "Modalidad de entrevista",
        "languages": "Idiomas",
        "atsProvider": "Proveedor ATS",
        "atsId": "ID de puesto en ATS",
        "noDescription": "Sin descripción."
      },
      "questions": {
        "title": "Preguntas de entrevista",
        "empty": "No hay preguntas configuradas para este puesto.",
        "optional": "Opcional",
        "categories": {
          "eligibility": "Elegibilidad",
          "nice_to_have": "Deseable",
          "job_preview": "Expectativas del puesto",
          "assessment": "Evaluación",
          "information": "Información"
        }
      }
    }
  },
  "wizard": {
    "step": "Paso {{current}} de {{total}}",
    "back": "Atrás",
    "next": "Continuar",
    "goLive": "Publicar",
    "saveAndContinue": "Guardar y continuar",
    "manual": {
      "title": "Nuevo empleo",
      "step1Title": "Información básica",
      "step2Title": "Preguntas de entrevista",
      "step3Title": "Confirmar y publicar"
    },
    "import": {
      "title": "Importar desde ATS",
      "step0Title": "Seleccionar empleos",
      "step1Title": "Mapear etapas",
      "step2Title": "Configuración de entrevista",
      "step3Title": "Preguntas de entrevista",
      "step4Title": "Confirmar y publicar"
    },
    "stageSelector": {
      "title": "Mapear etapas del pipeline",
      "description": "Selecciona qué etapa de cada empleo corresponde a cada acción de Kiku. Prellenado donde los nombres de etapa coinciden con tus valores predeterminados.",
      "continue": "Continuar",
      "loading": "Cargando etapas…"
    },
    "basicInfo": {
      "title": "Título del empleo",
      "titlePlaceholder": "ej. Ingeniero de Software Senior",
      "description": "Descripción del empleo",
      "descriptionPlaceholder": "Describe el rol, responsabilidades y requisitos...",
      "descriptionHint": "Usada por la IA para generar preguntas de entrevista relevantes",
      "employer": "Nombre del empleador (opcional)",
      "employerPlaceholder": "ej. Acme Corp",
      "modality": "Formato de entrevista",
      "modalityText": "Chat de texto",
      "modalityTextDesc": "El candidato escribe respuestas en una interfaz de chat",
      "modalityVoice": "Entrevista de voz",
      "modalityVoiceDesc": "Entrevista de audio en directo en una sala de reunión virtual",
      "languages": "Idioma(s) de entrevista",
      "languagesHint": "Selecciona al menos un idioma",
      "languagesSearch": "Buscar idiomas…",
      "languagesEmpty": "No se encontró ningún idioma.",
      "modalityRequired": "Selecciona al menos un formato de entrevista",
      "languagesRequired": "Selecciona al menos un idioma"
    },
    "atsSelector": {
      "title": "Seleccionar empleos a importar",
      "search": "Buscar empleos...",
      "selectAll": "Seleccionar todos",
      "selected": "{{count}} seleccionados",
      "noJobs": "No se encontraron empleos activos en tu ATS",
      "noDescription": "Sin descripción disponible — la IA generará desde el título",
      "continue": "Continuar con {{count}} empleo(s)"
    },
    "sharedSettings": {
      "title": "Configuración de entrevista",
      "subtitle": "Estas configuraciones se aplicarán a todos los empleos importados",
      "employer": "Nombre del empleador",
      "employerPlaceholder": "p.ej. Acme Corp"
    },
    "questions": {
      "title": "Preguntas de entrevista",
      "generateError": "Error al generar preguntas. Por favor, inténtalo de nuevo.",
      "retry": "Reintentar",
      "generating": "Preparando preguntas para encontrar a los mejores candidatos…",
      "generatingHint": "Esto suele tardar unos segundos",
      "addQuestion": "Agregar pregunta",
      "categories": {
        "eligibility": "Elegibilidad",
        "nice_to_have": "Deseable",
        "job_preview": "Vista previa realista del puesto",
        "assessment": "Evaluación",
        "information": "Recopilación de información"
      },
      "categoryDescriptions": {
        "eligibility": "Preguntas sí/no sobre requisitos obligatorios",
        "nice_to_have": "Preguntas sí/no sobre calificaciones deseables pero no obligatorias",
        "job_preview": "Destaca un aspecto desafiante del rol. Ayuda a asegurar que el candidato entiende lo que implica el puesto y previene la rotación",
        "assessment": "Preguntas de comportamiento y competencias",
        "information": "Preguntas para recopilar contexto — no se usan en la puntuación"
      },
      "categoryPurpose": {
        "eligibility": "Apto o no apto",
        "job_preview": "Apto o no apto",

        "assessment": "Puntuado",
        "information": "Solo informativo"
      },
      "optional": "Opcional",
      "competency": "Competencia",
      "scoringExamples": "Anclas de puntuación",
      "editScoringExamples": "Editar anclas de puntuación",
      "regenerateScoringExamples": "Regenerar anclas de puntuación",
      "dontRegenerateScoringExamples": "No regenerar anclas de puntuación",
      "regeneratingScoringExamples": "Regenerando...",
      "regenerateScoringError": "Error al regenerar anclas de puntuación",
      "score1": "Puntuación 1 — Deficiente",
      "score3": "Puntuación 3 — Adecuado",
      "score5": "Puntuación 5 — Excelente",
      "aiGenerated": "Generado por IA"
    },
    "confirm": {
      "title": "Listo para publicar",
      "jobsCount": "{{count}} empleo(s) serán activados",
      "questionsCount": "{{count}} pregunta(s) de entrevista",
      "modality": "Formato",
      "languages": "Idiomas",
      "goLiveHint": "Los candidatos podrán iniciar entrevistas inmediatamente después de la activación."
    }
  },
  "login": {
    "title": "Iniciar sesión en Kiku",
    "subtitle": "Gestiona tu proceso de reclutamiento.",
    "cta": "Iniciar sesión",
    "waitingForLogin": "Esperando inicio de sesión…",
    "disclosure": "Estás interactuando con un sistema de IA. Kiku usa IA para asistir en el reclutamiento — todas las decisiones están sujetas a revisión humana.",
    "errors": {
      "not_provisioned": "Tu cuenta aún no está configurada. Contacta a tu administrador.",
      "missing_code": "La autenticación falló. Por favor intenta de nuevo.",
      "session_expired": "Tu sesión ha expirado. Por favor inicia sesión de nuevo."
    }
  },
  "settings": {
    "profile": {
      "title": "Perfil",
      "name": "Nombre",
      "email": "Correo electrónico",
      "role": "Rol",
      "departments": "Departamentos"
    }
  },
  "integrations": {
    "title": "Integraciones",
    "ats": {
      "title": "Conexión ATS",
      "description": "Conecta tu Sistema de Seguimiento de Candidatos para sincronizar empleos y gestionar etapas.",
      "provider": "Proveedor",
      "apiKey": "Clave de API",
      "apiKeyPlaceholder": "Ingresa tu clave de API",
      "apiKeySet": "Clave guardada — ingresa un nuevo valor para reemplazarla",
      "save": "Guardar conexión",
      "verify": "Verificar conexión",
      "verifyStatus": {
        "valid": "Conectado",
        "invalid": "Clave inválida",
        "error": "Error de verificación",
        "idle": "Sin verificar",
        "loading": "Verificando..."
      },
      "providers": {
        "teamtailor": "Teamtailor",
        "recman": "RecMan",
        "logicmelon": "LogicMelon",
        "teamtailorDescription": "Teamtailor es una plataforma de reclutamiento que ayuda a las empresas a atraer, nutrir y contratar a los mejores candidatos.",
        "recmanDescription": "RecMan es un sistema de reclutamiento para agencias de personal y reclutamiento en el mercado nórdico.",
        "logicmelonDescription": "LogicMelon es un ATS de publicación múltiple para reclutamiento de alto volumen, popular en el sector educativo del Reino Unido."
      }
    },
    "stageMapping": {
      "title": "Mapeo de etapas",
      "description": "Mapea las etapas de tu ATS a las etapas del flujo de trabajo de Kiku.",
      "initialStage": "Etapa inicial",
      "passInterviewStage": "Pasar entrevista",
      "failInterviewStage": "Fallar entrevista",
      "recommendedStage": "Recomendado",
      "selectStage": "Selecciona una etapa",
      "save": "Guardar mapeo"
    },
    "errors": {
      "notConfigured": "No hay ATS configurado. Guarda tu conexión primero.",
      "fetchStagesFailed": "No se pudieron cargar las etapas de tu ATS.",
      "saveFailed": "Error al guardar la configuración."
    }
  },
  "applications": {
    "title": "Solicitudes",
    "newCandidate": "Nuevo candidato",
    "addCandidate": "Agregar nuevo candidato",
    "importFromCsv": "Importar desde CSV",
    "importDialog": {
      "title": "Importar candidatos",
      "back": "Atrás",
      "next": "Siguiente",
      "upload": {
        "hint": "Arrastra un archivo CSV aquí o haz clic para buscar",
        "csvOnly": "Solo archivos CSV",
        "browse": "Buscar archivo"
      },
      "mapping": {
        "headerRow": "La primera fila es una cabecera",
        "nameColumn": "Columna de nombre",
        "emailColumn": "Columna de correo",
        "phoneColumn": "Columna de teléfono",
        "notMapped": "— sin mapear —",
        "column": "Columna",
        "preview": "Vista previa"
      },
      "review": {
        "allValid": "Los {{count}} candidatos son válidos",
        "summary": "{{valid}} válidos · {{invalid}} inválidos",
        "skipInvalid": "Omitir filas inválidas e importar {{count}} candidatos válidos",
        "recheck": "Verificar",
        "import": "Importar {{count}} candidatos",
        "colName": "Nombre",
        "colEmail": "Correo",
        "colPhone": "Teléfono",
        "colStatus": "Estado"
      },
      "errors": {
        "nameRequired": "Requerido",
        "emailInvalid": "Correo inválido",
        "emailDuplicate": "Correo duplicado en este archivo",
        "phoneInvalid": "Requiere código de país (ej. +34…)"
      },
      "success": {
        "title": "Importación completada",
        "body": "{{created}} importados, {{conflict}} ya tenían solicitudes (omitidos), {{error}} fallaron.",
        "done": "Listo"
      }
    },
    "screening": "Selección",
    "aiRanked": "Ordenado por IA",
    "emptyStage": "Sin solicitudes",
    "emptyTitle": "Aún no hay candidatos",
    "emptyDescription": "Agrega tu primer candidato para comenzar a revisar solicitudes.",
    "emptySearchDescription": "Ningún candidato coincide con tu búsqueda.",
    "searchPlaceholder": "Buscar por nombre, correo o teléfono",
    "createDialog": {
      "title": "Agregar solicitud",
      "name": "Nombre completo",
      "namePlaceholder": "ej. María García",
      "email": "Correo electrónico",
      "emailPlaceholder": "ej. maria@ejemplo.com",
      "phoneNumber": "Número de teléfono",
      "phoneNumberPlaceholder": "ej. 555-1234",
      "phoneCountryCode": "Código de país",
      "phoneCountryCodePlaceholder": "ej. +34",
      "submit": "Crear solicitud"
    },
    "errors": {
      "conflict": "Este candidato ya tiene una solicitud para este puesto."
    },
    "detail": {
      "title": "Detalles de la solicitud",
      "tabs": {
        "application": "Solicitud",
        "profile": "Perfil",
        "activity": "Actividad"
      },
      "stage": "Etapa",
      "interviewLink": "Enlace de entrevista",
      "interviewStatus": "Estado de la entrevista",
      "copyLink": "Copiar enlace",
      "linkCopied": "Copiado!",
      "noInterview": "No se encontró sesión de entrevista",
      "noResults": {
        "title": "Entrevista no completada",
        "description": "Este candidato aún no ha realizado la entrevista. Comparte el enlace para comenzar."
      },
      "inProgress": {
        "title": "Entrevista en curso",
        "description": "Este candidato ha comenzado la entrevista. Los resultados aparecerán aquí una vez completada."
      },
      "openInterview": "Abrir entrevista",
      "commChannel": {
        "label": "Enviar por",
        "manual": "Manual",
        "email": "Correo electrónico",
        "sms": "SMS",
        "whatsapp": "WhatsApp"
      },
      "status": {
        "pending": "Pendiente",
        "in_progress": "En progreso",
        "completed": "Completada",
        "expired": "Expirada"
      }
    }
  },
  "pagination": {
    "rowsPerPage": "Filas por página",
    "rowsSelected": "{{count}} de {{total}} fila(s) seleccionada(s).",
    "pageOf": "Página {{page}} de {{total}}",
    "previous": "Anterior",
    "next": "Siguiente"
  },
  "screening": {
    "title": "Entrevista de selección",
    "aiDisclosure": "Estás conversando con Sara, una asistente de reclutamiento con IA",
    "selectLanguage": "Selecciona tu idioma preferido",
    "selectLanguageDescription": "La entrevista se realizará en el idioma que elijas",
    "startInterview": "Iniciar entrevista",
    "previewJobTitle": "Trabajo de ejemplo — Empresa de ejemplo",
    "typeMessage": "Escribe tu mensaje...",
    "send": "Enviar",
    "typing": "Sara está escribiendo...",
    "submitInterview": "Enviar entrevista",
    "loading": "Cargando entrevista...",
    "completed": {
      "title": "Entrevista completada",
      "submitted": "Entrevista enviada exitosamente",
      "message": "Gracias por completar la entrevista para {{jobTitle}}. Un reclutador revisará tus respuestas y se pondrá en contacto."
    },
    "expired": {
      "title": "Entrevista expirada",
      "message": "Este enlace de entrevista ha expirado. Por favor contacta al reclutador para una nueva invitación."
    },
    "notFound": {
      "title": "Entrevista no encontrada",
      "message": "Este enlace de entrevista no es válido. Por favor verifica el enlace e inténtalo de nuevo."
    },
    "feedback": {
      "helpUsImprove": "Ayúdanos a mejorar",
      "teaser": "¿Cómo fue tu experiencia en la entrevista?",
      "overallPrompt": "¿Cómo fue la experiencia general de la entrevista?",
      "disclaimer": "Nos encantaría tu opinión — es anónima y no afectará tu solicitud.",
      "prompt": "¿Cómo fue la entrevista?",
      "good": "Genial",
      "bad": "Mal",
      "notesLabel": "¿Algún comentario adicional?",
      "notesPlaceholder": "Cuéntanos más (opcional)...",
      "skip": "Omitir",
      "submit": "Enviar comentarios",
      "submitError": "No se pudieron enviar los comentarios. Por favor inténtalo de nuevo."
    },
    "technicalIssue": {
      "buttonLabel": "¿Problema técnico?",
      "modalTitle": "Reportar un problema técnico",
      "modalDescription": "Describe el problema que encontraste. Tus comentarios serán enviados y la entrevista se reiniciará.",
      "notesLabel": "¿Qué salió mal?",
      "notesPlaceholder": "p. ej. La página se congeló y perdí mi progreso...",
      "submitButton": "Enviar comentarios y reiniciar",
      "submitError": "No se pudo enviar. Por favor inténtalo de nuevo.",
      "cancel": "Cancelar"
    },
    "error": {
      "title": "Algo salió mal",
      "message": "Ocurrió un error. Por favor inténtalo más tarde.",
      "sendFailed": "No se pudo enviar el mensaje. Por favor inténtalo de nuevo."
    },
    "languages": {
      "en": "Inglés",
      "da": "Danés",
      "sv": "Sueco",
      "de": "Alemán",
      "fr": "Francés",
      "es": "Español",
      "nl": "Holandés",
      "pl": "Polaco",
      "fi": "Finlandés",
      "ro": "Rumano"
    },
    "landing": {
      "badge": "ENTREVISTA DE TRABAJO",
      "greeting": "¡Hola {{name}}! Nos alegra que estés aquí. Esta es una invitación para una breve entrevista de selección en línea con una IA para conocerte. Tómala cuando estés listo/a.",
      "startChat": "Iniciar entrevista por chat",
      "startVoice": "Iniciar entrevista por voz",
      "or": "o",
      "minutes": "{{count}} minutos",
      "questions": "{{count}} preguntas"
    },
    "modality": {
      "title": "Elige el formato de entrevista",
      "description": "Selecciona cómo deseas completar la entrevista",
      "text": "Entrevista de texto",
      "textDescription": "Escribe tus respuestas en un chat",
      "voice": "Entrevista de voz",
      "voiceDescription": "Di tus respuestas en voz alta"
    },
    "deviceTest": {
      "title": "Comprueba tu audio",
      "description": "Asegúrate de que tu micrófono y altavoces funcionen antes de empezar",
      "microphone": "Micrófono",
      "speakers": "Altavoces",
      "testMicrophone": "Permitir acceso al micrófono",
      "testSpeakers": "Reproducir sonido de prueba",
      "playAgain": "Reproducir de nuevo",
      "requestingPermission": "Solicitando permiso...",
      "microphoneDenied": "Se denegó el acceso al micrófono. Por favor, permite el acceso en la configuración de tu navegador.",
      "confirm": "Todo funciona — comenzar entrevista"
    },
    "voice": {
      "title": "Entrevista de voz",
      "connecting": "Conectando...",
      "recording": "Grabando",
      "interviewInProgress": "Entrevista en curso",
      "inProgress": "Entrevista en curso — habla con naturalidad",
      "muted": "Tu micrófono está silenciado",
      "finished": "Entrevista completada — ¡gracias!",
      "alreadyInProgress": "Entrevista en curso",
      "alreadyInProgressMessage": "Tu entrevista de voz está actualmente activa. Reiniciarla cancelará la sesión actual — hazlo solo si ya no estás conectado.",
      "retryButton": "Reiniciar entrevista"
    }
  },
  "scoring": {
    "title": "Resultados de la Entrevista",
    "pending": "Evaluación en progreso...",
    "processing": "La IA está evaluando la entrevista...",
    "failed": "La evaluación falló",
    "overallScore": "Puntuación General",
    "overallScoreTooltip": "Puntuación de 0 a 100 basada en el promedio de todas las preguntas de evaluación, ajustada por elegibilidad y expectativas del puesto.",
    "outcome": "Resultado",
    "outcomes": {
      "pass": "Aprobado",
      "fail": "No Aprobado"
    },
    "summary": "Resumen",
    "eligibility": "Elegibilidad",
    "niceToHave": "Deseables",
    "expectations": "Expectativas del Puesto",
    "assessment": "Evaluación",
    "information": "Recopilación de Información",
    "scoringAnchors": "Anclas de puntuación",
    "candidateAnswer": "Respuesta del candidato",
    "transcript": "Transcripción de la Entrevista",
    "viewInTranscript": "Ver en transcripción",
    "copyPasteDetected": "Respuesta copiada y pegada",
    "copyPasteWarning": "Se detectó copiar y pegar en esta entrevista",
    "copyPasteWarningTooltip": "Una o más respuestas del candidato fueron pegadas durante la entrevista. Esto puede indicar que el candidato utilizó respuestas preparadas con anticipación.",
    "recording": {
      "title": "Grabación de la entrevista"
    },
    "verdicts": {
      "pass": "Aprobado",
      "fail": "No Aprobado",
      "unsure": "Incierto",
      "review": "Necesita Revisión"
    },
    "optional": "Opcional",
    "averageScore": "Puntuación Promedio",
    "reasoning": "Razonamiento",
    "evidence": "Evidencia",
    "backToJob": "Volver al puesto",
    "overrideDialog": {
      "title": "Modificar puntuación",
      "titleVerdict": "Modificar veredicto",
      "currentValue": "Valor actual",
      "newValue": "Nuevo valor",
      "reason": "Razón de la modificación",
      "reasonPlaceholder": "Explica por qué estás cambiando esta puntuación...",
      "reasonMinLength": "Mínimo {{min}} caracteres requeridos",
      "save": "Guardar cambio",
      "cancel": "Cancelar",
      "error": "Error al guardar la modificación. Inténtalo de nuevo."
    }
  },
  "workflows": {
    "title": "Flujo de trabajo",
    "description": "Configura las etapas por las que pasan las solicitudes durante tu proceso de contratación.",
    "stages": {
      "title": "Etapas del proceso",
      "subtitle": "Arrastra para reordenar. Las solicitudes avanzan por estas etapas de arriba a abajo.",
      "system": "Sistema",
      "manage": "Gestionar etapas",
      "addStage": "Agregar etapa",
      "editStage": "Editar etapa",
      "deleteStage": "Eliminar etapa",
      "stageName": "Nombre de la etapa",
      "stageNamePlaceholder": "p. ej. Entrevista telefónica",
      "stageColor": "Color",
      "deleteConfirm": "¿Eliminar esta etapa? Las solicitudes en esta etapa deben moverse primero.",
      "systemProtected": "Las etapas del sistema no se pueden eliminar",
      "hasApplications": "Esta etapa todavía tiene solicitudes asignadas"
    }
  },
  "communications": {
    "title": "Comunicaciones de agente",
    "languageSelector": "Idioma",
    "tabs": {
      "sms": "SMS",
      "email": "Email"
    },
    "emailSubject": "Asunto",
    "emailBody": "Cuerpo",
    "variables": {
      "applicantName": "Nombre del solicitante",
      "jobTitle": "Título del puesto",
      "jobEmployer": "Empresa",
      "jobLocation": "Ubicación del puesto",
      "jobDescription": "Descripción del puesto",
      "recruiterName": "Nombre del reclutador",
      "inviteUrl": "URL de invitación"
    },
    "actions": {
      "edit": "Editar",
      "save": "Guardar cambios",
      "reset": "Restablecer por defecto",
      "saved": "Plantilla guardada",
      "resetDone": "Restablecida por defecto"
    },
    "nodes": {
      "interviewIntro": "Introducción de entrevista",
      "interviewOutro": "Cierre de entrevista",
      "reminderToFinish": "Recordatorio para terminar",
      "voiceAndChat": "Voz y chat",
      "emailsAndSms": "Emails y SMS",
      "comingSoon": "Próximamente"
    },
    "characters": "{{count}}/{{max}} caracteres",
    "smsSegments": "{{count}} SMS ({{size}} chars/segmento)",
    "smsUnicodeWarning": "Este mensaje contiene emojis o caracteres especiales que requieren codificación Unicode, lo que reduce el límite a 67 caracteres por SMS.",
    "invite": {
      "title": "Invitación de candidato",
      "description": "Los candidatos reciben esto cuando se añaden a una oferta de trabajo. El correo incluye automáticamente un enlace a la entrevista.",
      "email": {
        "subject": "¡Estás invitado/a a tu entrevista para {{jobTitle}}! 🎯",
        "body": "<p>Hola {{applicantName}},</p><p>Has sido invitado/a a completar una breve entrevista de selección con nuestro entrevistador IA para el puesto de <strong>{{jobTitle}}</strong> en <strong>{{jobEmployer}}</strong>.</p><p>Es una forma sencilla de conocerte mejor — hazla cuando quieras, desde cualquier lugar. ¡Solo toma unos minutos!</p><p><a href=\"{{inviteUrl}}\">Comenzar Entrevista</a></p><p>¡Buena suerte!<br>{{jobEmployer}}</p>"
      },
      "sms": "Hola {{applicantName}}, soy Sara, asistente de empleo IA de {{jobEmployer}}. Te invitamos a una entrevista para {{jobTitle}}. Solo toma unos minutos: {{inviteUrl}} (Sin respuestas)"
    },
    "reminder": {
      "title": "Recordatorio de entrevista",
      "description": "Enviado automáticamente si un candidato no ha iniciado su entrevista en las primeras 24 horas.",
      "email": {
        "subject": "No olvides tu entrevista para {{jobTitle}}",
        "body": "<p>Hola {{applicantName}},</p><p>Notamos que aún no has completado tu entrevista de selección IA para el puesto de <strong>{{jobTitle}}</strong> en <strong>{{jobEmployer}}</strong>.</p><p>Esta es tu oportunidad de dar un paso más — solo toma unos minutos, y completarla aumentará tus posibilidades de avanzar a la siguiente etapa.</p><p><a href=\"{{inviteUrl}}\">Completar Entrevista Ahora</a></p><p>Saludos,<br>{{jobEmployer}}</p>"
      },
      "sms": "Hola {{applicantName}}, un recordatorio amigable — aún no has completado tu entrevista para {{jobTitle}} en {{jobEmployer}}. Solo toma unos minutos: {{inviteUrl}} — Sara"
    },
    "emailBodyPlaceholder": "Escribe tu correo electrónico...",
    "preview": {
      "outroSampleIntro": "Eso es todo — ¡gracias por tus respuestas!",
      "outroSampleAnswer": "Sin problema, con gusto ayudo."
    },
    "intro": {
      "title": "Introducción de entrevista",
      "description": "El mensaje de apertura exacto que Sara dirá para saludar al candidato y preguntar si está listo para comenzar.",
      "scriptLabel": "Mensaje de introducción",
      "scriptPlaceholder": "Escribe el mensaje de apertura exacto que debe decir Sara...",
      "defaultScript": "¡Hola! Soy Sara, una asistente de reclutamiento IA de {{jobEmployer}}. Gracias por tomarte el tiempo para la entrevista de {{jobTitle}} — solo tomará unos minutos. ¿Estás listo/a para comenzar? 😊"
    },
    "outro": {
      "title": "Cierre de entrevista",
      "description": "El mensaje de cierre exacto que Sara dirá después de que se hayan respondido todas las preguntas.",
      "scriptLabel": "Mensaje de cierre",
      "scriptPlaceholder": "Escribe el mensaje de cierre exacto que debe decir Sara...",
      "defaultScript": "¡Eso es todo — muchas gracias por tu tiempo! Un reclutador revisará tus respuestas y se pondrá en contacto. ¡Buena suerte! 🙂"
    }
  },
  "activity": {
    "title": "Actividad",
    "stageChange": "Movido de {{from}} a {{to}}",
    "interviewCompleted": "Entrevista de selección completada",
    "scoreReceived": "Puntuación recibida: {{score}}/100",
    "applicationCreated": "Solicitud creada",
    "noteAdded": "Nota agregada",
    "bySystem": "Sistema",
    "byAi": "IA",
    "empty": "Sin actividad aún",
    "emptyTitle": "Sin actividad aún",
    "emptyDescription": "Las acciones y eventos de este candidato aparecerán aquí."
  },
  "atsPush": {
    "title": "Estado de Envío al ATS",
    "retry": "Reintentar Envío al ATS",
    "retrying": "Reintentando...",
    "rerunStep": "Volver a ejecutar este paso",
    "rerunConfirm": "Este paso ya se completó correctamente. Volver a ejecutarlo puede crear datos duplicados en tu ATS. ¿Continuar?",
    "steps": {
      "transcript": "Transcripción",
      "stage_move": "Cambio de Etapa"
    },
    "status": {
      "completed": "Enviado",
      "failed": "Fallido",
      "pending": "Pendiente"
    },
    "note": {
      "title": "Entrevista de Selección IA",
      "outcome": "Resultado",
      "score": "Puntuación",
      "summary": "Resumen",
      "eligibility": "Elegibilidad",
      "assessment": "Evaluación",
      "transcript": "Transcripción",
      "candidate": "Candidato",
      "interviewer": "Entrevistador",
      "pass": "Apto",
      "fail": "No apto",
      "review": "Revisión",
      "shortlist": "Preseleccionado",
      "reject": "Rechazado",
      "viewProfile": "Ver perfil del candidato en Kiku",
      "transcriptAndAssessment": "TRANSCRIPCIÓN Y EVALUACIÓN",
      "intro": "Introducción",
      "eligibilityQuestions": "Preguntas de elegibilidad",
      "jobExpectations": "Expectativas del puesto",
      "assessmentQuestions": "Preguntas de evaluación",
      "outro": "Cierre",
      "assessmentExplanation": "EXPLICACIÓN DE LA EVALUACIÓN",
      "unsure": "Incierto",
      "viewInKiku": "VER EN KIKU PARA MÁS DETALLES",
      "viewProfileLink": "Ver perfil del candidato en Kiku para ver explicaciones de puntuaciones"
    }
  },
  "topbar": {
    "whatsNew": "Novedades",
    "help": "Ayuda",
    "notifications": "Notificaciones"
  },
  "extension_candidate_banner": {
    "description": "Ver los detalles del candidato.",
    "description_with_transcript": "Ver la transcripción de la entrevista y los detalles del candidato.",
    "open_in_kiku": "Abrir",
    "dismiss": "Cerrar"
  },
  "environmentBanner": {
    "development": "Desarrollo",
    "test": "Pruebas"
  },
  "notFound": {
    "title": "Página no encontrada",
    "description": "La página que buscas no existe o ha sido movida.",
    "goHome": "Volver a Kiku"
  },
  "candidateProfile": {
    "title": "Candidatos",
    "cv": {
      "title": "CV / Currículum",
      "upload": "Subir CV",
      "replace": "Reemplazar CV",
      "uploadDescription": "Sube un CV para extraer datos estructurados del perfil",
      "uploadLimit": "Máx. 10 MB — PDF, DOCX, PNG, JPG, WEBP",
      "viewOriginal": "Ver CV original",
      "status": {
        "pending": "En cola",
        "processing": "Procesando...",
        "done": "Procesado",
        "failed": "Error en el procesamiento"
      },
      "parsed": {
        "title": "Perfil extraído",
        "skills": "Habilidades",
        "experience": "Experiencia",
        "education": "Formación",
        "languages": "Idiomas",
        "certifications": "Certificaciones",
        "present": "Actualidad"
      },
      "errors": {
        "unsupportedType": "Tipo de archivo no compatible. Por favor, sube un PDF, DOCX, PNG, JPG o WEBP.",
        "tooLarge": "Archivo demasiado grande. El tamaño máximo es de 10 MB.",
        "uploadFailed": "Error al subir el CV. Por favor, inténtalo de nuevo."
      }
    }
  },
  "results": {
    "exportLabel": "Exportar",
    "exportCsv": "Exportar CSV",
    "csv": {
      "headers": {
        "candidateName": "Nombre del candidato",
        "email": "Correo electrónico",
        "role": "Puesto",
        "stage": "Etapa",
        "overallScore": "Puntuación total",
        "outcome": "Resultado",
        "eligibility": "Elegibilidad",
        "expectations": "Expectativas",
        "avgScore": "Puntuación media",
        "interviewDate": "Fecha de entrevista",
        "status": "Estado"
      }
    },
    "emptyTitle": "Sin resultados aún",
    "emptyDescription": "Las entrevistas completadas aparecerán aquí.",
    "columns": {
      "candidate": "Candidato",
      "stage": "Etapa",
      "status": "Estado",
      "score": "Puntuación",
      "outcome": "Resultado",
      "eligibility": "Elegibilidad",
      "expectations": "Expectativas",
      "avgScore": "Puntuación media",
      "interviewDate": "Fecha de entrevista",
      "question": "Pregunta"
    },
    "statusLabels": {
      "pending": "Pendiente",
      "processing": "Procesando",
      "completed": "Completado",
      "failed": "Fallido",
      "no_interview": "Sin entrevista"
    },
    "questionSections": {
      "eligibility": "Elegibilidad",
      "job_preview": "Expectativas",
      "nice_to_have": "Deseables",
      "assessment": "Evaluación",
      "information": "Información"
    },
    "fields": {
      "reasoning": "Razonamiento",
      "evidence": "Evidencia",
      "response": "Respuesta",
      "avgScoreLabel": "Puntuación media",
      "interviewDate": "Fecha de entrevista"
    }
  },
  "orgSettings": {
    "title": "Configuración de organización",
    "branding": {
      "title": "Marca",
      "logo": "Logo de la organización",
      "logoDescription": "Sube un logo para reemplazar el logo predeterminado de Kiku en la barra de navegación.",
      "uploadLogo": "Subir logo",
      "removeLogo": "Eliminar logo",
      "logoHint": "PNG, JPG, WebP o SVG. Máx. 2 MB.",
      "uploadSuccess": "Logo actualizado correctamente",
      "removeSuccess": "Logo eliminado",
      "uploadError": "Error al subir el logo"
    },
    "timezone": {
      "title": "Zona horaria",
      "description": "Establece la zona horaria predeterminada para programar y mostrar fechas.",
      "label": "Zona horaria",
      "saveSuccess": "Zona horaria actualizada",
      "saveError": "Error al actualizar la zona horaria"
    },
    "save": "Guardar cambios"
  },
  "mcp": {
    "title": "Integración MCP",
    "subtitle": "Conecta asistentes de IA a Kiku mediante el Model Context Protocol",
    "whatIsMcp": "¿Qué es MCP?",
    "whatIsMcpDescription": "El Model Context Protocol (MCP) permite que asistentes de IA como Claude, ChatGPT y otras herramientas interactúen directamente con Kiku — listando empleos, visualizando candidatos y gestionando tu pipeline de reclutamiento a través de lenguaje natural.",
    "serverUrl": "URL del servidor",
    "copyUrl": "Copiar URL",
    "copied": "¡Copiado!",
    "availableTools": "Herramientas disponibles",
    "toolListJobs": "Buscar y listar ofertas de empleo con nombres de departamento, filtros por estado, estado de configuración y departamento.",
    "toolGetJob": "Obtener todos los detalles de una oferta de empleo específica, incluyendo nombre del departamento.",
    "toolCreateJob": "Crear una nueva oferta de empleo en un departamento.",
    "toolAdvanceSetup": "Avanzar un empleo a través de las etapas de configuración (borrador, preguntas_pendientes, listo, activo).",
    "toolListApplications": "Listar candidaturas para un empleo con nombres de etapa, estado de puntuación y resultado.",
    "toolGetInterviewResults": "Obtener resultados de entrevista IA para una candidatura — puntuación, resultado y desglose por pregunta con razonamiento.",
    "toolGetPipelineSummary": "Obtener un resumen del pipeline para un empleo — cantidad de candidatos por etapa con totales de aprobados/rechazados.",
    "setupTitle": "Configuración con Claude Desktop",
    "setupStep1": "Abre Claude Desktop",
    "setupStep2": "Haz clic en Customize en la barra lateral izquierda",
    "setupStep3": "Haz clic en Connectors, luego el icono +, luego Add custom connector",
    "setupStep4": "Ingresa Name: Kiku y la URL del servidor mostrada arriba",
    "setupStep5": "Haz clic en Add — Claude ahora puede usar tus datos de Kiku"
  }
}
